import { action, computed, thunk } from "easy-peasy";
import { fetchStore } from "../../services/store";
import {
  fetchCityIp,
  translateCity,
  fetchCityByCoordinates,
} from "../../services/cityIp";
import * as publicIp from "public-ip";

function getCityFunk(array) {
  let city2 = null;
  for (let i = 0; i < array.length; i++) {
    if (
      array[i].GeoObject &&
      array[i].GeoObject.metaDataProperty &&
      array[i].GeoObject.metaDataProperty.GeocoderMetaData &&
      array[i].GeoObject.metaDataProperty.GeocoderMetaData.Address
    ) {
      const arr =
        array[i].GeoObject.metaDataProperty.GeocoderMetaData.Address.Components;
      const city = arr.filter((el) => el.kind == "locality")[0];
      if (city) {
        city2 = city.name;
        break;
      }
    }
  }
  return city2;
}

export const cityIpModel = {
  stores: [],
  address: "",
  storesShow: computed((state) =>
    state.stores.filter((el) => {
      return (
        (state.city != ""
          ? state.city == "все"
            ? el
            : el.city.title.toLowerCase().includes(state.city.toLowerCase())
          : el) &&
        (state.optica ? el.optic : el) &&
        (state.privilege ? el.privilege : el) &&
        (state.address != ""
          ? el.map.toLowerCase().includes(state.address.toLowerCase())
          : el)
      );
    })
  ),
  privilege: false,
  optica: false,
  ip: null,
  city: "все",
  cityResponse: null,
  showPopup: false,
  error: null,
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setCityResponce: action((state, payload) => {
    state.cityResponce = payload;
  }),
  setIp: action((state, payload) => {
    state.ip = payload;
  }),
  setCity: action((state, payload) => {
    state.city = payload;
  }),
  setShowPopup: action((state, payload) => {
    state.showPopup = payload;
  }),
  getTranslate: thunk(async (actions, payload) => {
    try {
      const translate = await translateCity(payload);
      if (translate.success && translate.mess) {
        localStorage.setItem("city", translate.mess);
        localStorage.setItem("cityExp", Date.now() + 86400000);
        actions.setCity(translate.mess);
      }
    } catch (err) {
      actions.setError(err);
    }
  }),
  getCityByCoordinates: thunk(async (actions, payload) => {
    try {
      const request = await fetchCityByCoordinates(payload);
      if (request.mess.featureMember) {
        const city = getCityFunk(request.mess.featureMember);
        if (city) {
          localStorage.setItem("city", city);
          localStorage.setItem("cityExp", Date.now() + 86400000);
          actions.setCity(city);
        }
      }
    } catch (err) {
      actions.setError(err);
    }
  }),
  getIp: thunk(async (actions, payload) => {
    try {
      const request = await publicIp.v4();
      if (request && !request.error) {
        localStorage.setItem("ip", request);
        localStorage.setItem("ipExp", Date.now() + 86400000);
        actions.setIp(request);
      }
    } catch (err) {
      actions.setError(err);
    }
  }),
  getCityResponse: thunk(async (actions, payload, helpers) => {
    try {
      const { ip } = helpers.getState();
      const request = await fetchCityIp(ip);
      if (request && request.city) {
        await actions.getTranslate(request.city);
      }
      if (request && !request.error) actions.setCityResponce(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
  setStore: action((state, payload) => {
    state.stores = payload;
  }),
  setAddress: action((state, payload) => {
    state.address = payload;
  }),
  setPrivilege: action((state, payload) => {
    state.privilege = payload;
  }),
  setOptica: action((state, payload) => {
    state.optica = payload;
  }),
  getStores: thunk(async (actions, payload) => {
    try {
      const request = await fetchStore(payload);
      if (request && !request.error) actions.setStore(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
};
